import React, { useState, useEffect } from "react";
import {
  CHECKOUT_LINK,
  BASKET_PAGE_LINK,
  COURS_COLLECTIFS_PRODUCT_IDS,
  TESTS_PRODUCT_IDS,
  PERSONAL_TRAINING_PRODUCT_IDS,
  PLANS_ENTRAINEMENT_PRODUCT_IDS,
  BILANS_PRODUCT_IDS,
  CGV_TRAINING_PRODUCTS_IDS,
  CGV_PRODUCTS_IDS,
  VISIO_COURSCO_DISCOUNTED_PRODUCT_IDS,
  COURSCO_PRODUCT_IDS,
  FREE_TRAINING_DISCOUNTED_PRODUCT_IDS,
  BILANS_SESAMES_PRODUCT_IDS,
} from "../../common/constants";
import "./ActionButtons.scss";
import shortProductId from "../../common/helpers/shortId";
import { toast } from "react-toastify";

const ActionButtons = ({
  articles = [],
  seeCart,
  keepNavigating,
  checkoutBtn,
  popupName,
  className,
  store,
  purchasedProducts
}) => {
  const [cgv, setCgv] = useState({ training: false, normal: false });

  useEffect(() => {
    handleCGV();
  }, []);

  const handleCGV = async () => {
    let hasTrainingProduct = await Promise.all([
      articles.some((art) =>
        CGV_TRAINING_PRODUCTS_IDS.includes(shortProductId(art))
      ),
    ]);
    let hasNormalProduct = await Promise.all([
      articles.some((art) => CGV_PRODUCTS_IDS.includes(shortProductId(art))),
    ]);

    console.log(hasTrainingProduct[0] === true, hasNormalProduct[0] === true);
    const cgv = { training: false, normal: false };
    if (hasTrainingProduct[0] === true) cgv.training = true;

    if (hasNormalProduct[0] === true) cgv.normal = true;

    await setCgv(cgv);
  };
  const canProceedWithSale = async (e) => {
    e.preventDefault();
    e.persist();
    let canProceedBilan = false;
    let canProceedCoursco = false;
    // on ajoute automatiquement un produit correspondant à une période de free training gratuite lors de l'achat de certains produits.
    // Ici on va vérifier que ce produit gratuit n'est achetable qu'en présence dans le panier du produit qui débloque cette offre
    let canProceedFreeTrainingDiscount = false;
    // On ne veut pas qu'un user puisse acheter un produit de type training
    // ou un plan d'entrainement s'il n'a pas de bilan

    let hasBilanProduct = articles.some((art) =>
      BILANS_PRODUCT_IDS.includes(shortProductId(art))
    );
    let hasPTProduct = articles.some((art) =>
        PERSONAL_TRAINING_PRODUCT_IDS.includes(shortProductId(art))
    );
    // et des produits de type plans
    let hasPlansProduct = articles.some((art) =>
        PLANS_ENTRAINEMENT_PRODUCT_IDS.includes(shortProductId(art))
    );
    let hasTestProduct = articles.some((art) =>
        TESTS_PRODUCT_IDS.includes(shortProductId(art))
    );
    let hasCoursCo = articles.some((art) =>
        COURS_COLLECTIFS_PRODUCT_IDS.includes(shortProductId(art))
    );
    let hasSesames = articles.some((art) =>
        BILANS_SESAMES_PRODUCT_IDS.includes(shortProductId(art))
    );

    console.log(hasBilanProduct, hasPTProduct, hasPlansProduct, hasTestProduct)

    // Si on a pas de bilan
    if ((hasCoursCo || hasTestProduct) && !hasBilanProduct) {
        canProceedBilan = true;
    }
    else if (!hasBilanProduct) {
      // console.log('pas de bilan')
      let productCondition1   = ['SUBSCRIPTION_69070', 'COUNTER_2431', 'COUNTER_2432', 'COUNTER_2428', 'COUNTER_2429', 'COUNTER_2430', 'COUNTER_2436'],
          productCondition2_1 = ['COUNTER_2405', 'COUNTER_2406', 'COUNTER_2407', 'SUBSCRIPTION_35208'],
          productCondition2_2 = ['COUNTER_2410', 'COUNTER_2411', 'SUBSCRIPTION_35208'],
          trainingPlan        = ['COUNTER_20953', 'COUNTER_20954', 'COUNTER_9446', 'COUNTER_20955', 'COUNTER_9433', 'COUNTER_20956', 'COUNTER_9432', 'COUNTER_20957', 'COUNTER_20958', 'COUNTER_20959', 'COUNTER_9444', 'COUNTER_20960', 'COUNTER_20961', 'COUNTER_20962', 'COUNTER_20963', 'COUNTER_20964', 'COUNTER_20965', 'COUNTER_20966', 'COUNTER_20967', 'COUNTER_20968', 'COUNTER_20969', 'COUNTER_20970', 'COUNTER_9428', 'COUNTER_9430', 'COUNTER_9426', 'COUNTER_9424', 'COUNTER_9425'],
          sesames             = ['COUNTER_30852', 'COUNTER_32683', 'COUNTER_70902', 'COUNTER_70904', 'COUNTER_70905', 'COUNTER_70906', 'COUNTER_70907']
      ;

      if (productCondition1.some(r=> purchasedProducts.includes(r))
          || (productCondition2_1.some(r=> purchasedProducts.includes(r)) && productCondition2_2.some(r=> purchasedProducts.includes(r)))
          || trainingPlan.some(r=> purchasedProducts.includes(r)
          || sesames.some(r=> purchasedProducts.includes(r)))
      ) {
        canProceedBilan = true;
      }
      // On regarde si on a des produits de type personal training dans le panier
      else if (hasPTProduct || hasPlansProduct) {
        if (hasPTProduct) {
          toast.error(
            `Les séances de Personal Training ne peuvent être achetées qu'en complément d'un Bilan dans le cadre d'un Programme Personnalisé`
          );
        }
        if (hasPlansProduct) {
          toast.error(
            `Un plan d'entrainement ne peut être acheté qu'en complément d'un Bilan dans le cadre d'un Programme Personnalisé`
          );
        }
      }
    }
    else if (hasSesames && hasPlansProduct) {
      console.log('sesame + plans')
      canProceedBilan = true;
    }
    else if (hasBilanProduct && hasPTProduct && hasPlansProduct) {
      console.log('bilan + pt + plans')
      canProceedBilan = true;
    }
    else if (hasPTProduct && (!hasPlansProduct && !hasBilanProduct)) {
      console.log('pt sans plans ni bilan')
      let productCondition1   = ['SUBSCRIPTION_69070', 'COUNTER_2431', 'COUNTER_2432', 'COUNTER_2428', 'COUNTER_2429', 'COUNTER_2430', 'COUNTER_2436'],
          trainingPlan        = ['COUNTER_20953', 'COUNTER_20954', 'COUNTER_9446', 'COUNTER_20955', 'COUNTER_9433', 'COUNTER_20956', 'COUNTER_9432', 'COUNTER_20957', 'COUNTER_20958', 'COUNTER_20959', 'COUNTER_9444', 'COUNTER_20960', 'COUNTER_20961', 'COUNTER_20962', 'COUNTER_20963', 'COUNTER_20964', 'COUNTER_20965', 'COUNTER_20966', 'COUNTER_20967', 'COUNTER_20968', 'COUNTER_20969', 'COUNTER_20970', 'COUNTER_9428', 'COUNTER_9430', 'COUNTER_9426', 'COUNTER_9424', 'COUNTER_9425']
      ;

      if (productCondition1.some(r=> purchasedProducts.includes(r)) && trainingPlan.some(r=> purchasedProducts.includes(r))
      ) {
        canProceedBilan = true;
      }
    }
    else if (!hasPTProduct && hasPlansProduct && !hasBilanProduct) {
        console.log('plans sans pt ni bilan')
        let productCondition1   = ['SUBSCRIPTION_69070', 'COUNTER_2431', 'COUNTER_2432', 'COUNTER_2428', 'COUNTER_2429', 'COUNTER_2430', 'COUNTER_2436'],
            productCondition2_1 = ['COUNTER_2405', 'COUNTER_2406', 'COUNTER_2407', 'SUBSCRIPTION_35208'],
            productCondition2_2 = ['COUNTER_2410', 'COUNTER_2411', 'SUBSCRIPTION_35208'],
            trainingPlan        = ['COUNTER_20953', 'COUNTER_20954', 'COUNTER_9446', 'COUNTER_20955', 'COUNTER_9433', 'COUNTER_20956', 'COUNTER_9432', 'COUNTER_20957', 'COUNTER_20958', 'COUNTER_20959', 'COUNTER_9444', 'COUNTER_20960', 'COUNTER_20961', 'COUNTER_20962', 'COUNTER_20963', 'COUNTER_20964', 'COUNTER_20965', 'COUNTER_20966', 'COUNTER_20967', 'COUNTER_20968', 'COUNTER_20969', 'COUNTER_20970', 'COUNTER_9428', 'COUNTER_9430', 'COUNTER_9426', 'COUNTER_9424', 'COUNTER_9425']
        ;

        if (productCondition1.some(r=> purchasedProducts.includes(r))
            || (productCondition2_1.some(r=> purchasedProducts.includes(r)) && productCondition2_2.some(r=> purchasedProducts.includes(r)))
            || trainingPlan.some(r=> purchasedProducts.includes(r))
        ) {
          canProceedBilan = true;
        }
    }
    else {
        canProceedBilan = true;
    }

    // on regarde donc si on a l'un de ces produits remisés
    let hasDiscountedCourscoProducts = articles.some((art) =>
      VISIO_COURSCO_DISCOUNTED_PRODUCT_IDS.includes(shortProductId(art))
    );
    if (hasDiscountedCourscoProducts) {
      // On vérifie qu'il y a bien des produits cours co
      let hasNormalCourscoProducts = articles.some((art) =>
        COURSCO_PRODUCT_IDS.includes(shortProductId(art))
      );
      // s'il n'y en a pas, on déclenche un message d'erreur
      if (!hasNormalCourscoProducts) {
        toast.error(
          `Les visio séances remisées ne sont disponibles qu'en complément d'un abonnement ou de séances de cours collectifs`
        );
      } else {
        canProceedCoursco = true;
      }
    } else {
      canProceedCoursco = true;
    }

    // on regarde si le panier contient un produit de freetraining remisé
    let hasDiscountedFreeTraining = articles.some((art) =>
      FREE_TRAINING_DISCOUNTED_PRODUCT_IDS.includes(shortProductId(art))
    );
    if (hasDiscountedFreeTraining) {
      let hasPTProducts = articles.some((art) =>
        PERSONAL_TRAINING_PRODUCT_IDS.includes(shortProductId(art))
      );
      // s'il n'y en a pas, on déclenche un message d'erreur
      if (!hasPTProducts) {
        toast.error(
          `Les mois de Free Training gratuits ne sont disponibles qu'en complément de séances de Personal Training`
        );
      } else {
        canProceedFreeTrainingDiscount = true;
      }
    } else {
      canProceedFreeTrainingDiscount = true;
    }

    if (canProceedCoursco && canProceedBilan && canProceedFreeTrainingDiscount)
      e.currentTarget.submit();
  };

  return (
    <div className={`action-button-container ${className || ""}`}>
      {keepNavigating && keepNavigating === true && (
        <a
          className="keep-navigating-button"
          onClick={() => store.togglePopup(popupName, false)}
        >
          {" "}
          Continuer ma navigation
        </a>
      )}
      {seeCart && seeCart === true && (
        <form method="get" action={BASKET_PAGE_LINK}>
          <button className="elementor-button elementor-size-sm elementor-animation-shrink see-cart-button">
            Voir le Panier
          </button>
        </form>
      )}
      {checkoutBtn && checkoutBtn === true && (
        <form
          method="post"
          action={CHECKOUT_LINK}
          onSubmit={canProceedWithSale}
        >
          <input
            name="contactId"
            type="hidden"
            value={encodeURIComponent(
              `${localStorage.getItem("CONTACT").replace(/'/g, "%27")}` // On échappe les apostrophes sinon le parsing du json se fait mal coté php
            )}
          />
          <input
            name="accessToken"
            type="hidden"
            value={localStorage.getItem("ACCESS_TOKEN")}
          />

          <input name="sale" type="hidden" value={store.cartId} />
          <input
            name="cgv"
            type="hidden"
            value={encodeURIComponent(JSON.stringify(cgv))}
          />
          <button
            type="submit"
            className="elementor-button elementor-size-sm elementor-animation-shrink pay-button"
          >
            Paiement
          </button>
        </form>
      )}
    </div>
  );
};

export default ActionButtons;
